<template>
  <div class="fans">
    <div class="container fl">
      <span>粉丝总数</span>
      <h3>{{fan.befollowers}}</h3>
      <span>近30日 --</span>
    </div>
    <div class="container fl">
      <span>活跃粉丝数</span>
      <h3>{{fan.befollowers}}</h3>
      <span>近30日 --</span>
    </div>
    <div class="clear"></div>

    <h4>粉丝活跃度</h4>

    <div class="container">
      <span>粉丝总数</span>
      <h3>{{fan.befollowers}}</h3>
      <span>近30日 --</span>
    </div>

    <div class="container">
      <span>活跃粉丝数</span>
      <h3>{{fan.befollowers}}</h3>
      <span>近30日 --</span>
    </div>
  </div>
</template>

<style scoped>
.fans{background-color:#fff;padding:32px;}
h4{text-align: left;}
.clear {
  clear: both;
}
.fl{float:left;}
.container {
  margin-right: 10px;
  padding: 16px;
  width: 200px;
  background-color: #f7fcfe;
  font-size: 14px;
  margin-bottom: 16px;
}
h3 {
  padding: 0px;
  margin: 0px;
  padding: 8px 8px;
  color: #00a1d6;
  font-size:24px;
}
</style>
<script>
export default {
 mounted(){
  this.getMyData();
 },
 data(){
   return{
     fan:{}
   }
 },
 methods:{
   getMyData(){
     this.$http
        .get("/api/me?uid="+parseInt(localStorage.getItem("loginuid")))
        .then((r) => {
          this.fan=r.data;
        });
   }
 }
}
</script>
